module.exports = __webpack_public_path__ + "static/media/Bitmap.20f5486a.svg";